const maintenance = [
  {name: 'Замена воздушного фильтра', price: '300₽'},
  {name: 'Замена салонного фильтра', price: '300₽'},
  {name: 'Замена салонного  фильтра со снятием педального узла', price: '1.200₽'},
  {name: 'Замена фильтра топливного дизель(грубой очистки)', price: '300₽'},
  {name: 'Замена масла в коробке передач (мкпп)', price: '800₽'},
  {name: 'Замена масла в редукторе переднего моста', price: '600₽'},
  {name: 'Замена масла в раздаточной коробке (рк)', price: '600₽'},
  {name: 'Замена масла в редукторе заднего моста', price: '600₽'},
  {name: 'Замена жидкости в рулевом механизме', price: '1.000₽'},
  {name: 'Замена тормозной жидкости', price: '1.200₽'},
  {name: 'Замена приводного ремня (за один ремень)', price: '500₽'},
  {name: 'Промывка дроссельной заслонки(с учетом химии)', price: '1.500₽'},
  {name: 'Замена охлаждающей жидкости', price: '1.200₽'},
  {name: 'Доливка технической жидкости', price: '200₽'},
  {name: 'Замена топливного фильтра дизельного двигателя (тонкой очистки)', price: '850₽'},
  {name: 'Регулировка ручника  (1 сторона)', price: '400₽'},
  {name: 'Замена масла в акпп с фильтром', price: '2.500₽'},
  {name: 'Замена масла в акпп', price: '1.500₽'},
  {name: 'Замена масла ДВС', price: '500₽'},
  {name: 'Демонтаж монтаж защиты картера', price: '200₽'},
  {name: 'Замена свечей зажигания без снятие коллектора', price: '600₽'},
  {name: 'Замена свечей зажигания со снятием впускного коллектора', price: '2.000₽'},
  {name: 'Заправка кондиционера (стоимость работы без учета фреона)', price: '1.000₽'},
  {name: 'Замена катушки зажигания', price: '200₽'},
  {name: 'Обслуживание механизма петель кузова', price: '300₽'},
];

const brakeSystem = [
  {name:'Замена тормозного шланга', price: '400₽' },
  {name:'Замена тормозной трубки передний контур', price: '800₽'},
  {name:'Замена главного тормозного цилиндра', price: '1.200₽' },
  {name:'Замена тормозной жидкости', price: '1.200₽'},
  {name:'Прокачка тормозной системы, удаление воздуха', price: '1.200₽'},
  {name:'Замена передних тормозных колодок, дисковые тормоза', price:'700₽'},
  {name:'Замена рабочего цилиндра переднего тормозного механизма (переборка суппорта) с демонтажом', price: '1.500₽'},
  {name:'Замена рабочего цилиндра заднего тормозного механизма (переборка суппорта) с демонтажом', price: '1.500₽'},
  {name:'Замена переднего тормозного суппорта', price: '1.000₽'},
  {name:'Замена заднего тормозного суппорта', price: '1.000₽'},
  {name:'Обслуживание передних тормозных механизмов за 1ед', price: '250₽'},
  {name:'Обслуживание задних тормозных механизмов за 1ед', price: '250₽'},
  {name:'Замена колодок ручного тормоза при снятом тормозном диске 1 сторона', price: '500₽'},
  {name:'Обслуживание механизма ручного тормоза 1 сторона', price: '250₽'},
  {name:'Замена троса ручного тормоза за 1сторона', price: '1.500₽'},
  {name:'Регулировка привода ручного тормоза (ручника)1 сторона', price: '400₽'},
  {name:'Замена передних тормозных дисков (комплект)', price: '2.000₽'},
  {name:'Замена задних тормозных дисков (комплект)', price: '2.000₽'},
  {name:'Замена блока антиблокировочной системы (абс) тормозов (с адаптацией)', price: '5.000₽'},
  {name:'Замена задних тормозных барабанов 1сторона', price: '1.200₽'},
  {name:'Замена заднего тормозного цилиндра при снятом барабане 1 сторона', price: '500₽'},
];

const electrical = [
  {name:'Замена генератора', price: '1500₽'},
  {name:'Замена стартера', price: '1500₽'},
  {name:'Ремонт генератора', price: 'по согласованию'},
  {name:'Ремонт стартера', price: 'по согласованию'},
  {name:'Замена диодного моста генератора', price: 'по согласованию'},
  {name:'Замена втягивающего реле стартера', price: 'по согласованию'},
  {name:'Замена бендикса стартера', price: 'по согласованию'},
  {name:'Замена высоковольтных проводов', price: '400₽'},
  {name:'Замена свечей зажигания', price: '600₽'},
  {name:'Замена катушки зажигания', price: '200₽'},
  {name:'Замена модуля катушки зажигания', price: '400₽'},
  {name:'Замена реостата печки', price: '1500₽'},
  {name:'Замена электромотора вентилятора печки', price: '1500₽'},
  {name:'Замена электромотора стеклоочистителя ветрового стекласо снятием панели (жабо)', price: '2000₽'},
  {name:'Замена электронного блока управления эбу', price: '1.500₽'},
  {name:'Замена модуля кнопок стеклоподъемника', price: '800₽'},
  {name:'Замена блока управления отопителя печки кондиционера', price: '1.200₽'},
  {name:'Замена блока управления двигателя (эбу двс)', price: '800₽'},
  {name:'Замена подкапотного модуля предохранителей', price: '1.800₽'},
  {name:'Замена модуля предохранителей салонного', price: '1.200₽'},
  {name:'Замена модуля предохранителей багажника', price: '1.200₽'},
  {name:'Замена блока управления комфорта', price: '800₽'},
  {name:'Замена модуля управления центральным замком', price: '800₽'},
  {name:'Замена электромотора вентилятора охлаждения радиатора двигателя', price: '1.600₽'},
  {name:'Замена электромотора вентилятора охлаждения радиатора кондиционера', price: '1.600₽'},
  {name:'Замена электромотора стеклоподъемника', price: '1.500₽'},
  {name:'Замена силового провода на генератор', price: '450₽'},
  {name:'Замена силового провода на стартер', price: '800₽'},
  {name:'Замена массового провода', price: '500₽'},
  {name:'Ремонт жгута электропроводки за 1 час работы электрика', price: '1.500₽'},
  {name:'Замена лампочки без снятия фары', price: '250₽'},
  {name:'Замена звукового сигнала без снятия бампера', price: '350₽'},
  {name:'Замена контактного кольца рулевой колонки', price: '950₽'},
  {name:'Замена контактной группы замка зажигания', price: '1.500₽'},
  {name:'Замена актуатора замка двери со снятием катриджа дверной обшивки', price: '1.000₽'},
  {name:'Компьютерная диагностика', price: '500₽'},
  {name:'Диагностика мотор тест', price: '1.500₽'},
  {name:'Диагностика АКБ', price: '300₽'},
  {name:'Диагностика электро проводки  тестом на обрыв', price: '1.500₽'},
];

const chassis = [
  {name:'Демонтаж-монтаж поворотного кулака', price: '2.000₽'},
  {name:'Замена шпильки колеса при снятом тормозном диске(1ед)', price: '200₽'},
  {name:'Демонтаж-монтаж  передней стойки амортизатора', price: '1.500₽'},
  {name: 'Замена опорного подшипника передней стойки амортизатора(Со снятием амортизатора)', price:'1.500₽'},
  {name: 'Замена пружины передней стойки (со снятием амортизатора)', price:'1.500₽'},
  {name: 'Замена  рычага продольного задней подвески', price:'3.000₽'},
  {name: 'Замена левого рычага передней подвески', price:'2.500₽'},
  {name: 'Замена шаровой опоры рычага передней подвески не снимая рычага', price:'800₽'},
  {name: 'Замена ступицы переднего колеса в сборе с подшипником', price:'1.500₽'},
  {name: 'Замена втулки стабилизатора поперечной устойчивости передней задней подвески за 1 шт', price:'500₽'},
  {name: 'Замена стойки стабилизатора поперечной устойчивости передней задней подвески за 1 шт', price:'500₽'},
  {name: 'Замена подрамника передней подвески', price:'3.000₽'},
  {name: 'Замена нижнего рычага передней подвески', price:'1.500₽'},
  {name: 'Замена сайленблока рычага передней подвески при снятом рычаге', price:'500₽'},
  {name: 'Замена амортизатора задней подвески без пружины', price:'1.200₽'},
  {name: 'Замена пружины задней подвески (1 сторона)', price:'1.200₽'},
  {name: 'Замена ступицы заднего колеса', price:'1.500₽'},
  {name: 'Замена втулок стабилизатора перед- задней подвески за 1 шт', price:'500₽'},
  {name: 'Замена стойки стабилизатора  перед-задней подвески за 1 шт', price:'500₽'},
  {name: 'Перепресовка салейнблока (1ед)', price:'500₽'},
  {name: 'Замена продольного рычага задней подвески', price:'3.000₽'},
  {name: 'Замена поперечного нижнего рыгага задней подвески (сход-развального)', price:'1.200₽'},
  {name: 'Замена стабилизатора подвески заднего моста', price: '1.600₽'},
  {name: 'Замена сайленблока рычага задней подвески( при снятом рычаге)', price: '500₽'},
  {name: 'Перепресовка шаровай опоры при снятом рычаге', price:'500₽'},
  {name: 'Демонтаж-монтаж тормозного диска', price:'1.000₽'},
  {name: 'Замена втулок стабилизатора при отпускании подрамника', price:'2.000₽'},
];

const steering = [
  {name: 'Замена наконечника рулевой тяги', price:'600₽'},
  {name: 'Замена рулевой тяги и наконечника', price:'1.200₽'},
  {name: 'Замена рулевой рейки', price:'5.000₽'},
  {name: 'Регулировка схождения колес передней оси', price:'1.500₽'},
  {name: 'Регулировка схождения колес передней- задней  оси', price:'2.000₽'},
  {name: 'Замена насоса ГУР (Гидро Усилителя Руля)', price:'1.500₽'},
  {name: 'Шприцевание шарниров  за точку', price:'100₽'},
  {name: 'Замена шланга ГУР', price:'1.300₽'},
  {name: 'Замена рулевого редуктора', price:'1.500₽'},
  {name: 'Замена рулевой колонки', price:'4.500₽'},
  {name: 'Замена карданного вала рулевой колонки', price:'1.500₽'}
];

const engine = [
  {name: 'Замена двигателя - снять двигатель / поставить двигатель', price:'20.000₽'},
  {name: 'Замена двигателя - снять двигатель', price:'10.000₽' },
  {name: 'Замена двигателя - поставить двигатель', price:'10.000₽' },
  {name: 'Капитальный ремонт двигателя (без запчастей)', price: "от 3.5000" },
  {name: 'Замена головки блока цилиндров (гбц)', price:'15.000₽' },
  {name: 'Замена прокладки головки блока цилиндров (гбц)', price:'1.500₽' },
  {name: 'Замена сальника распределительного вала приснятом ГРМ', price:'500₽' },
  {name: 'Замена прокладки клапанной крышки', price:'1.500₽' },
  {name: 'Замена маслосъемных колпачков без снятия ГБЦ', price:'8.000₽' },
  {name: 'Замена впускных клапанов при снятой ГБЦ за 1 клапан', price:'350₽' },
  {name: 'Замена выпускных клапанов при снятой ГБЦ за 1 клапан', price:'350₽' },
  {name:'Замена направляющих клапанов при разобранной ГБЦ за 1 втулку', price:'350₽'},
  {name:'Обработка  седла клапана за 1 шт', price:'300₽'},
  {name:'Опрессовка головки блока цилиндров (гбц)', price:'2.000₽'},
  {name:'Шлифовка плоскости головки блока цилиндров (гбц)', price:'2.500₽'},
  {name:'Замена переднего сальника коленчатого вала (кв) при снятом ГРМ', price:'500₽'},
  {name:'Замена заднего сальника коленчатого вала (кв) при снятой КПП', price:'500₽'},
  {name:'Замена свечей зажигания', price:'600₽'},
  {name:'Замена ремня газораспределительного механизма (грм) 1.6л', price:'3.500₽'},
  {name:'Замена цепи газораспределительного механизма (ГРМ) 1.6л-2.0л', price:'9.500₽'},
  {name:'Замена ремня газораспределительного механизма (грм) 2.4л(Ховер-тиго)', price:'6.000₽'},
  {name:'Замена водяного насоса приснятом ГРМ', price:'500₽'},
  {name:'Замена приводного ремня (1ед)', price:'500₽'},
  {name:'Замена обводного ролика приводного ремня', price:'500₽'},
  {name:'Замена механизма натяжителя приводного ремня', price:'1.200₽'},
  {name:'Замена водяного насоса( если  не на ремне ГРМ)', price:'1.500₽'},
  {name:'Демонтаж монтаж шкива коленчетого вала (не ремень ГРМ)', price:'2.000₽'},
  {name:'Заменна сальника коленвала при снятом шкиве', price:'500₽'},
  {name:'Замена прокладки поддона картера', price:'3.000₽'},
  {name:'Замена масла ДВС', price:'500₽'},
  {name:'Замена опоры ДВС верхней', price:'800₽'},
  {name:'Замена опоры ДВС нижней', price:'1.200₽'},
  {name:'Замена прокладки крышки клапанов', price:'1.500₽'},
];

const transmission = [
  {name:'Замена автоматической коробки передач (акпп)-полный привод', price:'12.000₽'},
  {name:'Замена механической коробки передач (мкпп)-полный привод', price:'9.000₽'},
  {name:'Замена роботизированной коробки передач (мта, изитроник, робот)', price:'6500₽'},
  {name:'Ремонт механической коробки передач (мкпп) разборка-сборка', price:'8000₽'},
  {name:'Замена сальника первичного вала механической коробки передач (мкпп)', price:'500₽'},
  {name:'Замена раздаточной коробки передач (рк) со снятием МКПП', price:'10.000₽'},
  {name:'Замена сальника раздаточной коробки (рк)', price:'500₽'},
  {name:'Замена прокладки раздаточной коробки (рк)', price:'700₽'},
  {name:'Замена гидротрансформатора автоматической коробки передач', price:'12.000₽'},
  {name:'Замена сцепления механической коробки передач (мкпп)', price:'6.500₽'},
  {name:'Замена выжимного подшипника коробки передач (мкпп, мта, робот, изитроник)', price:'6.500₽'},
  {name:'Замена сцепления роботизированной коробки передач (мта, изитроник, робот)', price:'7.000₽'},
  {name:'Демонтаж монтаж карданного вала привода заднего переднего моста', price:'1.000₽'},
  {name:'Замена крестовины карданного вала при снятом кардане', price:'800₽'},
  {name:'Демонтаж монтаж  переднего привода (ШРУС)', price:'1.500₽'},
  {name:'Замена внутреннего пыльника привода (ШРУСа) передей оси при снятом приводе', price:'500₽'},
  {name:'Замена наружного пыльника привода (ШРУСа) переднего моста при снятом приводе', price:'500₽'},
  {name:'Замена гранаты ШРУСа переднего привода', price:'500₽'},
  {name:'Замена сальника  привода переднего моста при снятом приводе', price:'500₽'},
  {name:'Замена троса выбора передач без разбора салона', price:'1.500₽'},
  {name:'Демонтаж монтаж полуоси заднего моста', price:'2.000₽'},
  {name:'Замена подшипника полуоси( при снятой оси)', price:'500₽'},
];

const exhaust = [
  {name:'Демонтад монтаж впускного коллектора', price:'2.000₽'},
  {name:'Демонтад монтаж выпускного коллектора(1.4-2.0л мотор)', price:'3.500₽'},
  {name:'Замена  прокладки при снятом коллекторе', price:'500₽'},
  {name:'Замена  прокладки приемной трубы', price:'500₽'},
  {name:'Замена глушителя', price:'1.700₽'},
  {name:'Замена резонатора', price:'2.000₽'},
  {name:'Замена хомута выхлопной системы', price:'500₽'},
  {name:'Удаление катализатора (при снятом коллекторе)', price:'2.500₽'},
  {name:'Замена гофры выхлопной системы на авто', price:'2.000₽'},
  {name:'Замена гофры выхлопной системы (со снятием приемной трубы', price:'3.500₽'},
  {name:'Сварной шов', price:'700₽'},
];

const heater = [
  {name:'Замена основного радиатора (со снятием переднего бампера)', price:'3.000₽'},
  {name:'Замена осушителя кондиционера (со снятием приборной панели)', price:'12.000₽'},
  {name:'Замена радиатора отопителя салона (со снятием панели приборов', price:'12.000₽'},
  {name:'Замена патрубка радиатора верхнего-нижнего', price:'800₽'},
  {name:'Замена патрубка отопителя салона', price:'500₽'},
  {name:'Замена интеркуллера (со снятием бампера', price:'3.500₽'},
  {name:'Замена корпуса термостата', price:'1.200₽'},
  {name:'Замена термостата', price:'600₽'},
  {name:'Замена водяного насоса (помпа если не на ремне ГРМ', price:'2.000₽'},
  {name:'Замена охлаждающей жидкости', price:'1.200₽'},
  {name:'Прормывка системы ожлаждения дополнительно(при замене антифриза)', price:'500₽'},
  {name:'Опрессовка системы охлаждения', price:'800₽'},
];

const airConditioner = [
  {name:'Комплексная диагностика автокондиционера (визуальный осмотр магистрали и узлов, проверка на утечку хладагента, выявление причин неисправности)', price:'700₽'},
  {name:'Заправка автокондиционера фреоном без диагностики (просто заправить, до 800 гр.)', price:'1.500₽'},
  {name:'Заправка фреоном легковых авто до 800 гр. (осмотр, вакуумирование, долив компрессорного масла с УФ-красителем, проверка рабочего давления и утечки хладагента, повторная диагностика входит в стоимость)', price:'2.000₽'},
  {name:'Откачать и перезаправить (для замены какой-либо детали, для проведения ремонтных работ с использованием старого хладагента )', price:'2.000₽'},
  {name:'Демонтаж/Монтаж компрессора (1-ая категория, расположение сверху)', price:'1.200₽'},
  {name:'Демонтаж/Монтаж компрессора (2-ая категория, расположение снизу)', price:'2.200₽'},
  {name:'Демонтаж/Монтаж компрессора (3-ая категория, трудный доступ)', price:'3.500₽'},
  {name:'Демонтаж/Монтаж конденсатора (радиатор)', price:'от 1.200₽'},
  {name:'Демонтаж/Монтаж магистрали кондиционера', price:'от 600₽ (после осмотра)'},
  {name:'Демонтаж/Монтаж ресивера', price:'от 800₽'},
  {name:'Демонтаж/Монтаж ТРВ', price:'от 1.000₽'},
  {name:'Изготовление магистрали автокондиционера (шланг, фитинги со сваркой, обжимка) до 1м', price:'2.500₽'},
  {name:'Изготовление шланга (шланг, фитинги со сваркой, обжимка) от 1м', price:'2.800₽ + стоимость шланга/расходных материалов'},
  {name:'Промывка конденсатора напором воды спец хим. раствором для теплообменников со снятием бампера', price:'от 2.000₽'},
  {name:'Антибактериальная обработка системы кондиционирования воздуха (комплекс, пенный очиститель, освежитель, замена салонного фильтра)', price:'от 2.500₽'},
  {name:'Замена подшипника компрессора/муфы/катушки/шкива (компрессор снят)', price:'от 1.000₽ до 2.500₽'},
  {name:'Полная промывка системы с расходным мат-лом (промывочная жидкость, хладагент, компрессорное масло, различные уплотнения, прокладки), с заменой вышедших из строя узлов, с последующей сборкой, заправкой и гарантией', price:'12.000₽ - 25.000₽'},
  {name:'Замена магистрали заднего контура (с заправкой системы)', price:'12.000₽ - 22.000₽'},
];

const bodyWork = [
  {name:'Бампер передний-задний демонтаж монтаж', price:'от 1.500₽'},
  {name:'Разборка сборка бампера переднего –заднего', price:'от 1.000₽'},
  {name:'Окрас бампера', price:'от 7.000₽'},
  {name:'Крыло переднее демонтаж монтаж', price:'от 1.500₽'},
  {name:'Ремонт крыла переднего', price:'от 2.500₽'},
  {name:'Капот демонтаж монтаж', price:'от 1.000₽'},
  {name:'Ремонт капота', price:'от 3.500₽'},
  {name:'Окрас капота 1 сторона', price:'от 8.000₽'},
  {name:'Демонтаж монтаж двери крышки багажника', price:'от 1.500₽'},
  {name:'Разборка сборка двери крышки багажника', price:'от 1.500₽'},
  {name:'Окрас двери 1 сторона', price:'от 7.000₽'},
  {name:'Ремонт порога', price:'от 3.500₽'},
  {name:'Окрас порога( с анти гравийной защитой)', price:'от 7.500₽'},
  {name:'Окрас заднего крыла', price:'от 7.000₽'},
  {name:'Демонтаж монтаж (фары- фонаря )', price:'от 3.500₽'},
  {name:'Установка автомобиля на стапель', price:'от 10.000₽'},
]

// {name:'', price:},
// {name:'', prices:[]},

const complexTiresWork = [
  { name: 'Балансировка со снятием и чисткой: балансировка, снятие и установка',
    prices: {
      car: ['800', '1.100', '1.200', '1.400', '1.800', '2.200','3.000'],
      SUVs: ['1.100', '1.200','1.600', '1.900', '2.200', '2.600', '3.400']
    }
  },
  { name: 'Замена шин со сбором колёс: балансировка, демонтаж, монтаж, снятие и установка',
    prices: {
      car: ['1.500', '1.600', '1.900', '2.400', '3.000', '3.900','5.300'],
      SUVs: ['1.900', '2.100','2.500', '3.200', '3.600', '4.500', '6.100']
    }
  },
  { name: 'Замена шин со сбором колёс профиль < 50%, M/T, RunFlat или C : балансировка, демонтаж, монтаж, снятие и установка',
    prices: {
      car: ['1.800', '2.200', '2.600', '3.700', '4.500', '5.700','7.300'],
      SUVs: ['2.900', '3.200','3.500', '4.900', '5.900', '6.500', '9.300']
    }
  },
  { name: 'Сбор с балансировкой: балансировка, монтаж, установка вентиля',
    prices: {
      car: ['900', '900', '1.000', '1.400', '1.800', '2.100','3.000'],
      SUVs: ['1.100', '1.200','1.400', '1.800', '2.200', '2.400', '3.400']
    }
  },
  { name: 'Сбор с балансировкой профиль < 50%, M/T, RunFlat или C: балансировка, монтаж, установка вентиля',
    prices: {
      car: ['1.000', '1.200', '1.400', '2.000', '2.600', '3.000','4.100'],
      SUVs: ['1.600', '1.800','1.900', '2.700', '3.400', '3.400', '5.200']
    }
  },
];

const standartTiresWork = [
  {name: 'Балансировка', prices:{
    // 130	140	160	210	280	310	410
    // 170	180	220	280	340	360	470
    car:['130','140','160','210','280','310','410'],
    SUVs: ['170','180','220','280','340','360','470']
  }},
  {name: 'Демонтаж', prices:{
    // 80	85	90	120	130	220	260
    // 100	110	120	160	160	250	300
    car:['80','85','90','120','130','220','260'],
    SUVs: ['100','110','120','160','160','250','300']
  }},
  {name: 'Демонтаж профиль < 50%, M/T, RunFlat или C', prices:{
    // 120	150	180	270	300	440	490
    // 230	250	240	360	420	500	660
    car:['120','150','180','270','300','440','490' ],
    SUVs: ['230','250','240','360','420','500','600']
  }},
  {name: 'Монтаж', prices:{
    // 80	85	90	125	160	210	320
    // 100	110	120	170	190	240	370
    car:['80','85','90','125','160','210','320'],
    SUVs: ['100','110','120','170','190','240','370']
  }},
  {name: 'Монтаж профиль < 50%, M/T, RunFlat или C', prices:{
    // 120	150	180	290	360	420	600
    // 230	250	240	390	500	480	820
    car:['120','150','180','290','360','420','600'],
    SUVs: ['230','250','240','390','500','480','820']
  }},
  {name: 'Адаптация шины к диску', prices:{
    // 225	225	250	350	425	550	675
    // 275	300	350	450	500	625	775
    car:['225','225','250','350','425','550','675'],
    SUVs: ['275','300','350','450','500','625','775']
  }},
  {name: 'Снятие и установка', prices:{
    // 70	90	120	135	170	235	320
    // 90	120	160	180	200	270	370
    car:['70','90','120','135','170','235','320'],
    SUVs: ['90','120','160','180','200','270','370']
  }}
];

export {
  bodyWork,
  airConditioner,
  heater,
  exhaust,
  transmission,
  engine,
  steering,
  chassis,
  electrical,
  maintenance,
  brakeSystem,
  complexTiresWork,
  standartTiresWork
}




































